import { SYSTEM_MAIL_TYPES, TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_SystemMailCreated extends _Event {
    constructor(payload: EventSchema<Template_SystemMailCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            mailContent: z.string().min(1),
            mailHTMLContent: z.string().min(1),
            name: z.nativeEnum(SYSTEM_MAIL_TYPES),
            subject: z.string().min(1),
            type: z.literal(TEMPLATE_TYPES.SYSTEM_MAIL),
        });
    }

    static example(): EventSchema<Template_SystemMailCreated> {
        return {
            mailContent: 'This is the mail content',
            mailHTMLContent: '<html><body>This is the mail HTML content</body></html>',
            name: SYSTEM_MAIL_TYPES.system_applicant_confirmation,
            subject: 'Important Message',
            type: TEMPLATE_TYPES.SYSTEM_MAIL,
        };
    }
}
